import axios from "axios";

export const settingsService ={
	getSettings,
	getBusinessDay,
	getActiveBusinessDay,
	getLastBusinessDay,
	getBusinessDays,
}

function getSettings(){
	return axios.get(`/settings`).then((res) => {
		return res.data
	}).catch((err) => {
		return Promise.reject(err)
	})
}

function getBusinessDay() {
	// return axios.get(`/settings`).then((res) => {
	// 	return res.data
	// }).catch((err) => {
	// 	return Promise.reject(err)
	// })
	// return {status: 'rolled'};

}

function getActiveBusinessDay(status) {
	return axios.get(`/business-days`, {
		params: {
			page: 1,
			per_page: 1,
			active: status
		}
	}).then((res) => {
		return res.data
	}).catch((err) => {
		return Promise.reject(err)
	})
}
function getLastBusinessDay(status) {
	return axios.get(`/business-days/last`).then((res) => {
		return res.data
	}).catch((err) => {
		return Promise.reject(err)
	})
}

async function getBusinessDays(params) {
	const { data } = await axios.get(`/business-days`, {
		params: params
	});

	return data;
}
